<!-- Hero Section -->
<div class="softwaredev-section-bg">
    <section class="softwaredev-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <h1 class="softwaredev-heading mb-3">
                        Autonomous Machine Revolution & Rise of Machine Agency - 2026
                    </h1>
                    <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
                    <div class="mb-5 contact-btn">
                        <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
                        <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
                    </div>
                </div>

                <div class="col-lg-7 text-center">
                    <img src="../../../../assets/resources/whitepaper/autonomous-machine-revolution/autonomous-machine-revolution-banner.png"
                        alt="Autonomous Machine Revolution & Rise of Machine Agency - 2026"
                        class="img-fluid hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
    <div class="container">
        <h2 class="section-title text-center">TL;DR</h2>
        <div class="takeaways-list">
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>The Autonomous Machine Revolution marks a shift from traditional automation to machine agency, where
                    machines perceive, decide, act, learn, and transact independently without human intervention.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Enabled by the convergence of AI, IoT, advanced robotics, 5G/edge computing, and blockchain, machines
                    are evolving into economic actors within a growing machine-to-machine (M2M) economy.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Real-world deployments such as autonomous tractors, self-refueling logistics fleets, and smart
                    factories prove how machines now collaborate, negotiate payments, and self-improve at scale.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>This transformation unlocks 20–30% cost savings, higher productivity, sustainability gains, and new
                    business models, including robot-as-a-service and decentralized machine marketplaces.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>However, it introduces critical challenges around ethics, liability, cybersecurity, governance,
                    workforce transition, and value alignment, requiring urgent regulatory and societal frameworks.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>The future depends on responsible design and governance, positioning humans as strategists,
                    ethicists, and overseers, ensuring autonomous systems align with human values rather than purely
                    economic optimization.</p>
            </div>
        </div>
    </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
    <div class="container">
        <h2 class="section-title text-center">Key Takeaways</h2>
        <div class="takeaways-list">
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>Machine Agency is the Next Phase of Automation:</strong> Autonomous machines move beyond
                    rule-based automation to independent decision-making using AI, real-time data, and adaptive learning
                    models.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>AI and IoT Are the Core Enablers of Autonomy:</strong> Artificial intelligence, IoT sensors,
                    robotics, and edge/cloud computing form the foundational stack enabling autonomous operations at
                    scale.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>Autonomous Machines Drive Operational Efficiency:</strong> Continuous operation, predictive
                    maintenance, dynamic scheduling, and self-optimization reduce downtime and improve asset
                    utilization.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>The Machine-to-Machine Economy Is Emerging:</strong> Decentralized ledgers provide secure,
                    auditable, and tamper-resistant infrastructure for machine-to-machine payments and agreements.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>New Business Models Are Being Created:</strong> Models such as Robot-as-a-Service,
                    outcome-based pricing, and autonomous asset monetization are reshaping enterprise value chains.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>Governance and Ethics Are Critical to Scale Autonomy:</strong> Explainable AI,
                    human-in-the-loop controls, accountability frameworks, and regulatory standards are essential to
                    mitigate risk and ensure trust.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>Cybersecurity Becomes a Strategic Priority:</strong> Economically autonomous machines
                    increase the attack surface, making secure identities, resilient architectures, and continuous
                    monitoring mandatory.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>The Future of Work Is Human-Centered, Not Machine-Replaced:</strong> Humans transition into
                    system designers, supervisors, ethicists, and decision architects while repetitive execution shifts
                    to machines.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p><strong>Leadership Decisions Will Shape Outcomes:</strong>The autonomous machine revolution will
                    benefit society only if organizations intentionally embed human values into autonomous systems.</p>
            </div>
        </div>
        <button class="btn case-study-btn" (click)="openModal()">
            <i class="ri-download-2-line"></i> Download the Complete White Paper
        </button>
    </div>
</section>
<!-- Relavent Article -->
<app-relevant-whitepaper></app-relevant-whitepaper>


<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
    <div class="modal-content-box">
        <button class="close-btn" (click)="closeModal()">&times;</button>

        <div class="modal-header" *ngIf="!submitSuccess">
            <h3>Download White Paper</h3>
            <p>Fill in your details to receive the white paper.</p>
        </div>

        <div *ngIf="submitSuccess" class="success-message text-center">
            <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
            <h4>Thank you!</h4>
            <p>Check your email for the download link.</p>
            <small style="color: #666;">Please check your spam folder if you don't see it.</small>
        </div>

        <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
            <div class="form-group">
                <label>Full Name</label>
                <input type="text" formControlName="name" class="form-control" placeholder="Name">
                <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

                    <span *ngIf="downloadForm.get('name')?.errors?.['required']">
                        Name is required
                    </span>

                    <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
                        Name should contain only letters
                    </span>

                </div>
            </div>

            <div class="form-group">
                <label>Email Address</label>
                <input type="email" formControlName="email" class="form-control" placeholder="Email">
                <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

                    <span *ngIf="downloadForm.get('email')?.errors?.['required']">
                        Email is required
                    </span>

                    <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
                        Enter a valid email address
                    </span>

                </div>
            </div>

            <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

            <div class="modal-footer">
                <button type="submit" class="submit-btn" [disabled]="isSubmitting">
                    {{ isSubmitting ? 'Processing...' : 'Download Now' }}
                </button>
            </div>
        </form>
    </div>
</div>